import type { UseFormReturn } from "react-hook-form";
import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  TextInput,
  Typography,
} from "@/components/ui";
import { repairTypeOptions } from "@/pages/public/repairIntakeForm/repairIntakeFormConstants";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeSection3Props = {
  form: UseFormReturn<RepairIntakeFormData>;
  repairTypes: string[];
  onToggleRepairType: (value: string) => void;
};

export function RepairIntakeSection3({ form, repairTypes, onToggleRepairType }: RepairIntakeSection3Props) {
  return (
    <>
      <div className="space-y-3">
        <Typography variant="text-small" weight="medium">
          1. Repair Type *
        </Typography>
        <Typography variant="text-small" className="text-gray-600">
          Example: Trap, Wrap Only, Patch, Corrosion protection
        </Typography>
        <div className="grid gap-3 sm:grid-cols-2">
          {repairTypeOptions.map((option) => (
            <Checkbox
              key={option}
              checked={repairTypes.includes(option)}
              label={option}
              onChange={() => onToggleRepairType(option)}
            />
          ))}
          <Checkbox
            checked={repairTypes.includes("Other")}
            label="Other:"
            onChange={() => {
              onToggleRepairType("Other");
              if (repairTypes.includes("Other")) {
                form.setValue("section3.repairTypeOther", "", {
                  shouldDirty: true,
                  shouldTouch: true,
                  shouldValidate: true,
                });
              }
            }}
          />
        </div>
        {repairTypes.includes("Other") ? (
          <FormField
            control={form.control}
            name="section3.repairTypeOther"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <TextInput placeholder="Other repair type" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        ) : null}
        <Typography variant="validationError">{form.formState.errors.section3?.repairTypes?.message}</Typography>
      </div>

      <FormField
        control={form.control}
        name="section3.designPressure"
        render={({ field }) => (
          <FormItem>
            <FormLabel>2. Design Pressure *</FormLabel>
            <FormControl>
              <TextInput placeholder="100 PSI, 400 PSI, 120 PSI, -30PSI" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="section3.designTemperature"
        render={({ field }) => (
          <FormItem>
            <FormLabel>3. Design Temperature *</FormLabel>
            <FormControl>
              <TextInput placeholder="200F, 350F, 670F" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="section3.operatingPressure"
        render={({ field }) => (
          <FormItem>
            <FormLabel>4. Operating Pressure *</FormLabel>
            <FormControl>
              <TextInput placeholder="150PSI, 250PSI, 300PSI, -30PSI" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="section3.operatingTemperature"
        render={({ field }) => (
          <FormItem>
            <FormLabel>5. Operating Temperature *</FormLabel>
            <FormControl>
              <TextInput placeholder="200F, 350F, 670F" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
